var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.65625,
    width: 24.75,
    height: 24.1875,
    rx: 6,
    fill: "#FFD2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7892 8.71174H3.28955L7.21088 4.89087H22.7106L18.7892 8.71174Z",
    fill: "#F0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7892 20.609H3.28955L7.21088 16.79H22.7106",
    fill: "#F0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21088 14.6605H22.7106L18.7892 10.8396H3.28955",
    fill: "#F0A0A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolu);
export default __webpack_public_path__ + "static/media/solu.fdaf06459ee4ed27cc76d7dd7ad05771.svg";
export { ForwardRef as ReactComponent };